import { SignIn } from "@clerk/remix";

// This prevents the header from being displayed on login page
export const handle = { hideHeader: true };

export default function SignInPage() {
  return (
    <div className="h-[calc(100vh-2rem)] lg:h-[calc(100vh-80px)] flex justify-center content-center flex-wrap">
      <SignIn routing={"path"} path={"/sign-in"} />
    </div>
  );
}
